export const text = {
  header: "Inquiries",
  greeting:
    "Send us a message and one of our representatives will get back to you as soon as possible.",
  submission: "Submitted - Thank You!",
  button: "Submit",
};
